class AxReadMore extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('[data-ax-read-more-content]');
    this.toggle = this.querySelector('[data-ax-read-more-toggle]');
    if (!this.content || !this.toggle) return;

    this.toggle.addEventListener('click', () => this.#toggleExpanded());

    this.resizeObserver = new ResizeObserver(() => this.#refreshToggleVisibility());
    this.resizeObserver.observe(this.content);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  #refreshToggleVisibility() {
    if (this.content.hasAttribute('data-expanded')) return;
    this.toggle.hidden = this.content.scrollHeight <= this.content.clientHeight + 1;
  }

  #toggleExpanded() {
    const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
    this.toggle.setAttribute('aria-expanded', String(!expanded));
    this.content.toggleAttribute('data-expanded', !expanded);
  }
}

customElements.define('ax-read-more', AxReadMore);
